import React, { useEffect, useState } from 'react';
import './Pagination.style.scss';

interface IProps {
  page: number;
  pages: number;
  handlePageClick: (newPage: number) => void;
}

const Pagination = ({ page, pages, handlePageClick }: IProps) => {
  const [pagesToRender, setPagesToRender] = useState([1]);

  useEffect(() => {
    const newPagesToRender = [];

    for (let i = 0; newPagesToRender.length < 3; i++) {
      let pageToAdd = -(1 + i);

      if (pages - page === 0) {
        pageToAdd = page - (3 - i);
      } else if (pages - page === 1) {
        pageToAdd = page - (2 - i);
      } else {
        pageToAdd = page - (1 - i);
      }

      if (pageToAdd >= 1) {
        newPagesToRender.push(pageToAdd);
      }

      if (pageToAdd === pages) {
        break;
      }
    }
    setPagesToRender(newPagesToRender);
  }, [page, pages]);

  return pages > 1 ? (
    <ul className="pagination">
      <li onClick={() => page !== 1 && handlePageClick(page - 1)}>
        <span className="material-icons">arrow_back_ios</span>
      </li>

      <li
        onClick={() => handlePageClick(1)}
        className={page === 1 ? 'selected' : undefined}
      >
        {1}
      </li>

      {pagesToRender.includes(1) || pagesToRender.length <= 1 || (
        <span>...</span>
      )}
      {pagesToRender.map(
        (pageToRender) =>
          pageToRender !== pages &&
          pageToRender !== 1 && (
            <li
              key={pageToRender}
              className={pageToRender === page ? 'selected' : undefined}
              onClick={() => handlePageClick(pageToRender)}
            >
              {pageToRender}
            </li>
          )
      )}

      {pagesToRender.includes(pages) || <span>...</span>}

      {pagesToRender.length !== 1 && (
        <li
          onClick={() => handlePageClick(pages)}
          className={page === pages ? 'selected' : undefined}
        >
          {pages}
        </li>
      )}

      <li onClick={() => page !== pages && handlePageClick(page + 1)}>
        <span className="material-icons">arrow_forward_ios</span>
      </li>
    </ul>
  ) : null;
};

export default React.memo(Pagination);
